export const SCREEN_NAME = 'financial-results';

//filters
export const FILTERS = 'filters';

export const FILTER_ADDED = 'created';
export const FILTER_PERIOD = 'period';
export const FILTER_ACTIONS_TYPE = 'actionsType';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_APPROVERS = 'approvers';

export const FILTER_BUSINESS_PARTNERS = 'businessPartners';
export const FILTER_AFFILIATES = 'affiliates';
export const FILTER_CUSTOMER_COMPANIES = 'customerCompanies';
export const FILTER_CREATED_BY = 'owners';
export const FILTER_EXPENSE_TYPES = 'expenseTypes';
export const FILTER_IMPORTANCE = 'importance';
export const FILTER_STATUSES = 'statuses';

// searchQuery
export const SEARCH_QUERY = 'searchQuery';

export const TABLE_SETTINGS = 'tableSettings';

// columns
export const COLUMN_ID = 'id';
export const COLUMN_PERIOD = 'period';
export const COLUMN_EXPENSE_TYPE = 'expenseType';
export const COLUMN_BUSINESS_PARTNER = 'businessPartner';
export const COLUMN_BUSINESS_PARTNER_ID = 'businessPartnerId';
export const COLUMN_AFFILIATES = 'affiliates';
export const COLUMN_AFFILIATE_IDS = 'affiliateIds';
export const COLUMN_CUSTOMER_COMPANY = 'customerCompany';
export const COLUMN_APPLICATION = 'application';
export const COLUMN_ROAS_D7 = 'roasD7';
export const COLUMN_BUSINESS_PARTNER_COUNTRY = 'businessPartnerCountry';
export const COLUMN_CPI = 'cpi';
export const COLUMN_CVR = 'cvr';
export const COLUMN_REGS = 'regs';
export const COLUMN_SPENDING = 'spending';
export const COLUMN_TOTAL_INVOICES_AMOUNT = 'totalInvoicesAmount';
export const COLUMN_AMOUNT_GAP = 'amountGap';
export const COLUMN_STATUS = 'status';
export const COLUMN_OWNER = 'owner';
export const COLUMN_HISTORY_APPROVERS = 'historyApprovers';
export const COLUMN_IMPORTANCE = 'importance';
export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_LAST_UPDATED_DATE = 'lastUpdatedDate';
export const COLUMN_PAYMENT_DATE = 'paymentDate';
export const COLUMN_IO_BUDGET_ROR_FR = 'ioBudgetForFr';
export const COLUMN_IO_DOCUMENT_PERIODS = 'ioDocumentPeriods';
export const COLUMN_DUE_DATE = 'dueDate';
export const COLUMN_UA_REJECTED_INSTALLS =
  'uaRejectedInstallsByPostAttributionFraud';
export const COLUMN_RE_REJECTED_INSTALLS =
  'reRejectedInstallsByPostAttributionFraud';
export const COLUMN_TOTAL_REJECTED_INSTALLS =
  'totalRejectedInstallsByPostAttributionFraud';

export const TAB_DETAILS = 'Details';
export const TAB_INVOICES = 'Invoices';
export const TAB_ACTIONS_LOG = 'Actions Log';

export const FR_PAGE = 2;

export const STATUS_DELETED = -1;
export const STATUS_DRAFT = 0;
export const STATUS_PROCESSING = 1;
export const STATUS_APPROVED = 2;
export const STATUS_REJECTED = 3;
export const STATUS_ERROR = 4;
export const STATUS_PENDING_DR = 5;
export const STATUS_PENDING_BC = 6;
export const STATUS_PENDING_VP = 7;
export const STATUS_PENDING_PAID = 8;
export const STATUS_PENDING_MORE_INFO = 9;
export const STATUS_INVOICED = 10;
export const STATUS_PARTIALLY_PAID = 11;
export const STATUS_PENDING_IO = 12;
export const STATUS_SAP_REJECTED = 13;
export const STATUS_PENDING_SADJ = 14;
export const STATUS_PENDING_TL = 15;
export const STATUS_PENDING_COMPLETION = 16;
export const STATUS_PENDING_AM = 17;
